/* 關張傳・第 2 章：宕渠・從他道邀郃（建安二十年，215）
 * 史實：《三國志·張飛傳》「曹公破張魯，留夏侯淵、張郃守漢川。郃別督諸軍下巴西，欲徙其民於漢中，進軍宕渠、蒙頭、蕩石，
 *       與飛相拒五十餘日。飛率精卒萬餘人，從他道邀郃軍交戰，山道迮狹，前後不得相救，飛遂破郃。郃棄馬緣山，
 *       獨與麾下十餘人從間道退，引軍還南鄭，巴土獲安。」（醉酒誘敵、智取瓦口隘是演義。）
 * 流程：1. 相拒五十餘日：在前線擋住張郃先鋒的試探（日數一路跳）。
 *       2. 問他道：西邊荊棘封路，到村裡問土人，他帶路後小徑才開。
 *       3. 夜行邀擊：張郃的縱隊趕著百姓沿北邊窄谷往西走。走小徑從谷的中段殺進去。
 *          縱隊分成四段，谷道窄，「前後不得相救」：每段只顧自己那一截；但若先在東邊谷口正面撞上，全軍收攏結陣壓上來。
 *       4. 四段都被擊破，張郃棄馬緣山而走（劇情），巴土獲安。整條縱隊出了谷就失敗。 */
// @ts-nocheck
import { SG } from '../../core/sg.ts';
import { setLevel, boss, hero, rout, vanish, TROOPS } from '../kit.ts';
import { spare, calm } from './guanzhang_kit.ts';
import { ROAD_Y, GORGE, GAP, CAMP, FRONT, MOUTH, VILLAGE, THICKET } from '../maps/guanzhang_dangqu.ts';

const LV = 14, HOLD = 45, SEG = 4, GAP_X = 650, SPEED = 42, HEAD0 = MOUTH[0] - 300, LEASH = 460;
const WEI = { spec: TROOPS.wei, name: '魏兵', hp: 520, maxHp: 520, atk: 28 };

export default {
  id: 'guanzhang-2', map: 'guanzhang_dangqu', hero: 'zhangfei',
  title: '第 2 章　宕渠・從他道邀郃', year: '建安二十年（215）',
  brief: {
    quote: [{ text: '飛率精卒萬餘人，從他道邀郃軍交戰，山道迮狹，前後不得相救，飛遂破郃。', src: '《三國志·蜀書·張飛傳》' }],
    text: '曹操平定漢中，張魯投降，留夏侯淵、張郃守漢川。張郃帶兵南下巴西，想把當地百姓遷往漢中，進軍宕渠、蒙頭、蕩石。張飛領巴西太守，與張郃相拒。',
    goals: ['相拒：擋住張郃先鋒的試探', '問土人，找出林中的他道', '夜行：從他道殺進谷中，截斷張郃的縱隊', '擊破縱隊，巴土獲安'],
  },
  words: { ally: '精卒', foe: '魏兵' },
  stars: [
    { text: '從他道邀擊：沒在東邊谷口正面撞上張郃', ok: (m) => !m.vars.frontal },
    { text: '截斷縱隊：在縱隊前頭走過谷中段之前殺進谷裡', ok: (m) => !!m.vars.cutAhead },
    { text: '精卒折損不超過 3 人', ok: (m) => m.stats.lost <= 3 },
  ],
  steps: [
    { // 0. 相拒五十餘日
      enter(m, w) {
        const me = w.player, V = m.vars;
        setLevel(w, me, LV);
        me.x = FRONT[0]; me.y = FRONT[1] + 200;
        V.t0 = w.t; V.probeT = 4;
        m.gate('thicket', THICKET[0], THICKET[1], 170, 'abatis', ['張飛', '林子密成這樣，路在哪裡？……找個本地人問問。']);
        V.guide = m.folk(VILLAGE[0] + 60, VILLAGE[1] - 80, { name: '巴西土人', still: true, near: 170, lines: [
          ['巴西土人', '將軍要往北去谷裡？大路得繞到東邊的谷口，那裡全是魏兵。'],
          ['巴西土人', '西邊林子裡有條採藥的小路，荊棘長滿了，外人看不出來。'],
          ['巴西土人', '小人給將軍帶路。從那裡出去，正好在谷的半腰上。'],
        ], onHeard: () => { V.asked = true; } });
        m.line('張飛', '張郃那廝想把巴西的百姓都遷到漢中去——休想！');
        m.after(3, () => m.line('提示', '先在前線擋住張郃的試探；閒下來可以到西南的村子走走。'));
        m.obj('hold', '');
      },
      tick(m, w, dt) {
        const V = m.vars, t = w.t - V.t0;
        V.probeT -= dt;
        if (V.probeT <= 0 && t < HOLD - 6) { V.probeT = 11; for (let i = 0; i < 4; i++) { const u = m.foe('huangjin', 5600 + (i % 2) * 90, 2700 + Math.floor(i / 2) * 90, WEI); u.home = [FRONT[0] + 80, FRONT[1]]; } }
        m.get('hold').text = `與張郃相拒（第 ${Math.min(50, Math.floor((t / HOLD) * 50) + 1)} 日）`;
        return t >= HOLD && !w.units.some((u) => u.team === 1 && u.alive && SG.gd(u.x, u.y, FRONT[0], FRONT[1]) < 700);
      },
    },
    { // 1. 問他道
      enter(m, w) {
        const V = m.vars;
        m.done('hold');
        m.card('與飛相拒五十餘日。', '《張飛傳》');
        m.after(2, () => m.line('張飛', '五十多天了，硬碰硬沒個完。得找別的路繞過去。'));
        if (!V.asked) m.mark('guide', V.guide.x, V.guide.y, '巴西土人');
        m.obj('ask', '問土人：有沒有別的路');
      },
      tick(m, w) { return !!m.vars.asked; },
    },
    { // 2. 夜行邀擊
      enter(m, w) {
        const me = w.player, V = m.vars;
        m.done('ask'); m.unmark('guide');
        m.ungate('thicket');
        V.night = true; V.t2 = w.t;
        m.line('張飛', '好！精卒隨我來，今夜就從這條小路走！');
        V.men = Array.from({ length: 10 }, (_, i) => { const u = m.recruit(me.x - 60 - (i % 5) * 45, me.y + 60 + Math.floor(i / 5) * 70, '精卒'); u.spec = TROOPS.shu; u.hp = u.maxHp = 520; u.atk = 24; m.join(u, me); return u; });
        // 縱隊：四段，每段五個兵；張郃在第二段；後兩段夾著被遷的百姓
        V.head = HEAD0;
        V.segs = Array.from({ length: SEG }, (_, k) => {
          const cx = HEAD0 + k * GAP_X, units = Array.from({ length: 5 }, (_, i) => { const u = m.foe('huangjin', cx + (i % 3) * 70 - 70, ROAD_Y - 80 + Math.floor(i / 3) * 160, WEI); u.seg = k; u.dx = (i % 3) * 70 - 70; u.dy = -80 + Math.floor(i / 3) * 160; return u; });
          const folks = k >= 2 ? Array.from({ length: 3 }, (_, i) => m.folk(cx + 40, ROAD_Y + 30, { name: '巴西百姓', still: true, near: 1, look: i, dx: 120 + i * 40, dy: (i - 1) * 50 })) : [];
          return { k, units, folks, broken: false, cx };
        });
        V.zh = boss(w, hero('zhanghe'), HEAD0 + GAP_X, ROAD_Y, { name: '張郃', hp: 4200, atk: 46, armor: 9, ms: 250 });
        V.zh.seg = 1; V.zh.dx = 0; V.zh.dy = 0; V.segs[1].units.push(V.zh);
        spare(w, V.zh, (u) => flee(m, w, u));
        m.after(2, () => m.line('提示', '張郃的縱隊正沿北邊的山谷往西走。走小徑從谷的中段殺進去；別從東邊谷口正面撞上去。'));
        m.mark('gap', GAP[0], GAP[1] + 200, '他道出口');
        m.obj('cut', '從他道邀郃軍');
      },
      tick(m, w) {
        const me = w.player, V = m.vars;
        if (me.y < ROAD_Y + 280 && Math.abs(me.x - GAP[0]) < 500) { V.cutAhead = V.head > GAP[0]; return true; }
        return !!V.frontal;
      },
    },
    { // 3. 前後不得相救
      enter(m, w) {
        const V = m.vars;
        m.done('cut'); m.unmark('gap');
        V.ambush = true;
        if (V.frontal) { m.big('張郃結陣！'); m.line('張郃', '張飛來了！全軍收攏，結陣迎敵！'); }
        else { m.big('從他道殺出！'); m.line('張飛', '燕人張益德在此！'); m.after(2.5, () => m.line('魏兵', '前面的過不來，後面的也上不去！')); }
        for (const S of V.segs) for (const f of S.folks) { f.still = false; f.home = [f.x, f.y + 120]; f.goal = null; } // 百姓四散
        m.obj('segs', '擊破張郃的縱隊', SEG);
      },
      tick(m, w) {
        const V = m.vars;
        for (const S of V.segs) {
          if (S.broken) continue;
          const left = S.units.filter((u) => u.alive && !u.rout && u !== V.zh);
          if (left.length <= 1) { S.broken = true; rout(m, w, left, [S.cx < 2500 ? 200 : S.cx, 400]); m.line('魏兵', '這一截守不住了！'); }
        }
        const n = V.segs.filter((S) => S.broken).length;
        m.prog('segs', n);
        return n >= SEG;
      },
    },
    { // 4. 巴土獲安
      enter(m, w) {
        const V = m.vars;
        m.done('segs');
        if (V.zh.alive && !V.zh.subdued) flee(m, w, V.zh);
        m.after(3, () => m.card('飛遂破郃。郃棄馬緣山，獨與麾下十餘人從間道退，引軍還南鄭，巴土獲安。', '《張飛傳》'));
        m.after(8, () => m.win());
      },
      tick() { return false; },
    },
  ],
  always(m, w, dt) {
    const me = w.player, V = m.vars;
    if (!me.alive) { m.lose('張飛陣亡'); return; }
    calm(w);
    if (!V.segs) return;
    // 正面撞上：從東邊谷口進來，全軍收攏
    if (!V.frontal && !V.ambush && me.y < 2300 && me.x > 5600) V.frontal = true; // 東邊谷口一帶
    if (!V.ambush) V.head -= SPEED * dt; // 行軍
    for (const S of V.segs) {
      S.cx = V.head + S.k * GAP_X;
      for (const f of S.folks) if (f.still) { f.x = S.cx + f.dx; f.y = ROAD_Y + f.dy; f.walk = true; f.f = -1; }
      for (const u of S.units) {
        if (!u.alive || u.rout || u.subdued) continue;
        if (V.frontal) { u.home = [me.x, me.y]; continue; } // 結陣：全部壓上來
        u.home = [Math.max(GORGE[0] - 600, S.cx + u.dx), ROAD_Y + u.dy];
        // 山道迮狹：只顧自己那一截，追出去太遠就回來
        if (u.target && SG.gd(u.target.x, u.target.y, S.cx, ROAD_Y) > LEASH) { u.target = null; u.think = 0.6; }
      }
    }
    // 整條縱隊出了谷：百姓被遷走了
    if (!V.ambush && V.head + (SEG - 1) * GAP_X < GORGE[0]) m.lose('張郃帶著百姓出了谷，徙民而去');
  },
  overlay(ctx, m, view, x0, y0, vw, vh) {
    if (!m.vars.night) return;
    ctx.fillStyle = 'rgba(12,18,48,.45)'; ctx.fillRect(x0, y0, vw, vh);
  },
};
// 張郃棄馬緣山：丟下兵往北邊的山上爬，追不到
function flee(m, w, u) {
  if (u.fled) return;
  u.fled = true; u.untargetable = true; u.st.stun = 0;
  m.line('張郃', '……棄馬！上山！');
  rout(m, w, [u], [u.x, 300]);
  m.after(5, () => vanish(w, u));
}
